import { Link } from 'react-router-dom';
import phoenixHero from '../../assets/phoenix-hero-heart-close.png';

export function LandingPage() {
  return (
    <main>
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-b from-phoenix-blue-950 via-phoenix-blue-900 to-phoenix-blue-800">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-6 py-24 text-center md:py-32">
          <img
            src={phoenixHero}
            alt="Stylized line-art pair of phoenixes, mirrored to form a heart"
            className="h-56 w-auto md:h-72"
          />
          <div>
            <h1 className="font-serif text-4xl font-bold tracking-tight text-white md:text-5xl">
              Design that rises above the ordinary
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-phoenix-blue-100">
              Blue Phoenix Designs is a home &amp; interior design studio, blending thoughtful
              architecture with warm, livable style.
            </p>
            <div className="mt-8 flex justify-center gap-4">
              <Link
                to="/contact"
                className="rounded-md bg-phoenix-ember-500 px-8 py-3 font-semibold text-white transition hover:bg-phoenix-ember-600"
              >
                Start a Conversation
              </Link>
              <Link
                to="/login"
                className="rounded-md border border-white/30 px-8 py-3 font-semibold text-white transition hover:bg-white/10"
              >
                Client Portal
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="mx-auto max-w-4xl px-6 py-20">
        <h2 className="font-serif text-3xl font-bold text-phoenix-blue-900">Our Story</h2>
        <p className="mt-6 text-lg leading-relaxed text-gray-700">
          Blue Phoenix Designs was founded by a couple who fell in love with the craft of
          home-making one renovation at a time. Today the studio is focused on carefully restoring
          and reimagining a portfolio of single family homes — testing ideas, materials, and
          layouts in real homes before we bring them to clients.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-gray-700">
          Our full range of services includes design and renovation work for select clients who
          want a partner who has genuinely lived through the process — from structural changes to the
          final styling details. Whether it&apos;s a single room refresh or a full renovation, we
          bring the same care to our clients that we bring to our own homes.
        </p>
        <div className="mt-10 grid gap-6 sm:grid-cols-3">
          <div className="rounded-lg border border-gray-200 p-6">
            <h3 className="font-serif text-xl font-semibold text-phoenix-blue-900">
              Whole-Home Renovation
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">
              Structural, mechanical, and cosmetic renovation planning grounded in real
              experience.
            </p>
          </div>
          <div className="rounded-lg border border-gray-200 p-6">
            <h3 className="font-serif text-xl font-semibold text-phoenix-blue-900">
              Interior Design
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">
              Layouts, materials, and finishes tailored to how a family actually lives.
            </p>
          </div>
          <div className="rounded-lg border border-gray-200 p-6">
            <h3 className="font-serif text-xl font-semibold text-phoenix-blue-900">
              Project Guidance
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">
              Hands-on advice for homeowners navigating their own renovation projects.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-phoenix-blue-50">
        <div className="mx-auto max-w-4xl px-6 py-16 text-center">
          <h2 className="font-serif text-2xl font-bold text-phoenix-blue-900">
            Interested in working together?
          </h2>
          <p className="mt-3 text-gray-600">
            We&apos;re taking on a limited number of client projects — reach out to say hello.
          </p>
          <Link
            to="/contact"
            className="mt-6 inline-block rounded-md bg-phoenix-blue-600 px-8 py-3 font-semibold text-white transition hover:bg-phoenix-blue-700"
          >
            Get in Touch
          </Link>
        </div>
      </section>
    </main>
  );
}
